__turbopack_context__.v({
  "description": "entity-products-modal-module-scss-module__bln9Ga__description",
  "modal": "entity-products-modal-module-scss-module__bln9Ga__modal",
  "wideText": "entity-products-modal-module-scss-module__bln9Ga__wideText",
});
